export default "__VITE_ASSET__DcGS2i7___"